module.exports = __webpack_public_path__ + "static/media/logoBlack.9384f52d.png";